export default "__VITE_ASSET__BimOp0Ow__"